import { forwardRef, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { selectGolfClub } from '@sweetspot/club-portal-legacy/store/actions'

import ButtonGroup from './components/ButtonGroup'
import GolfClubSelect from './components/GolfClubSelect'

import { CacheBuster } from '@sweetspot/shared/util/cache-buster'
import { CacheInfo } from '@sweetspot/club-portal-legacy/components/CacheInfo/CacheInfo'
import { ReactComponent as SweetspotLogo } from '@sweetspot/club-portal-legacy/resources/images/sweetspot-logo.svg'
import { useMobileSideBarStore } from '@sweetspot/club-portal-legacy/hooks/useMobileSideBarStore'
import { Button } from '@sweetspot/scramble-ds/atoms'
import { DeviceType, useDeviceType } from '@sweetspot/scramble-ds/utils'

interface HeaderProps {
  updateMenu: () => void
}

const Header = forwardRef<HTMLDivElement, HeaderProps>(({ updateMenu }: HeaderProps, ref) => {
  const dispatch = useDispatch()
  const { toggleMobileSideBar } = useMobileSideBarStore()
  const { deviceType } = useDeviceType()
  const history = useHistory()
  const golfClubs = useSelector((state) => state.golfClub)
  const handleSelectGolfClub = (id: number, initial: boolean, redirect: boolean) => {
    dispatch(selectGolfClub(id, initial, redirect))
  }

  const isSingleClub = golfClubs?.list?.length === 1
  const isMobile = deviceType === DeviceType.MOBILE

  const handleLogoClick = useCallback(() => {
    history.push('/')
    updateMenu()
  }, [history, updateMenu])

  const centerContent = useMemo(
    () =>
      isMobile && isSingleClub ? (
        <SweetspotLogo onClick={handleLogoClick} className="h-[30px] w-fit cursor-pointer" />
      ) : (
        <GolfClubSelect golfClubs={golfClubs} selectGolfClub={handleSelectGolfClub} />
      ),
    [golfClubs, handleLogoClick, handleSelectGolfClub, isMobile, isSingleClub]
  )

  return (
    <div
      ref={ref}
      className="bg-background-sand-lighter border-bg-background-sand-lighter z-50 grid h-[76px] grid-cols-[52px_1fr_max-content_max-content] gap-x-2 border-b-2 pl-0.5 md:grid-cols-[200px_1fr_max-content_max-content] md:pl-0"
    >
      <div className="flex items-center justify-center ">
        <SweetspotLogo
          onClick={handleLogoClick}
          className="hidden h-[30px] cursor-pointer place-self-center md:block"
        />
        <Button
          variant="clear-dark"
          size="small"
          className="p-2 md:hidden"
          onClick={toggleMobileSideBar}
        >
          <i className="fa-solid fa-bars text-content-xl" />
        </Button>
      </div>
      <div className="flex h-full w-full items-center justify-center">{centerContent}</div>
      <CacheBuster>
        <CacheInfo />
      </CacheBuster>
      <ButtonGroup />
    </div>
  )
})

export default Header
